import React from 'react';
// import { Route, Link } from "react-router-dom";



const Home = () => (
    <div>
      <div className="cb-hero">

        <div className="cb-logo">
          <img src={process.env.PUBLIC_URL + "/img/cbr_logo.svg"} alt={"Homepage background"}/>
        </div>

        {/*<div className="cb-pagetitle">*/}
        {/*<h1 className="cb-authorname">*/}
        {/*Christoph &nbsp; Breitbach*/}
        {/*</h1>*/}

        {/*<div className="cb-authordoes">*/}
        {/*<div className="cb-cell">copywriter</div>*/}
        {/*<div className="cb-separator">|</div>*/}
        {/*<div className="cb-cell">creative director</div>*/}
        {/*</div>*/}
        {/*</div>*/}

      </div>
    </div>
);

export { Home };


// WEBPACK FOOTER //
// ./src/includes/Home.jsx